import { SidebarProvider } from "@project/components/ui/sidebar";
import { AppSidebar } from "@project/components/AppSidebar";
import { AppHeader } from "@project/components/AppHeader";
import { MobileBottomNav } from "@project/components/MobileBottomNav";
import { useAIAssistant } from "@project/hooks/useAIAssistant";
import { Sparkles } from "lucide-react";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { open: openAI } = useAIAssistant();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        {/* Sidebar hidden on mobile — bottom nav replaces it */}
        <div className="hidden sm:block">
          <AppSidebar />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <AppHeader />
          <main className="mesh-gradient flex-1 overflow-auto p-4 pb-24 sm:p-6 sm:pb-6">
            {children}
          </main>
        </div>
      </div>
      <MobileBottomNav />

      {/* Mobile AI Assistant FAB */}
      <button
        onClick={openAI}
        className="fixed bottom-20 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-primary-glow shadow-lg shadow-primary/30 transition-transform active:scale-95 sm:hidden"
      >
        <Sparkles className="h-5 w-5 text-primary-foreground" />
      </button>
    </SidebarProvider>
  );
}
